// extracted by css-extract-rspack-plugin
export default {"container":"trZfY4nE57QQUUeb__container___","resolvedBuyers":"FfzqDl1IgNEFhSfM__resolvedBuyers___"};